<template>
  <div id="app">
    <Main>
      <router-view />
    </Main>
  </div>
</template>

<script>
import Main from '@/views/Main'
export default {
  name: 'App',
  components: {
    Main
  }
}
</script>

<style lang="less">
.size{
  width: 100%;
  height: 100%;
}
html,body{
  .size;
  margin: 0;
  padding: 0;
  background-color: #F8F8F8;
}
#app {
  .size;
}
</style>
